import { enUS, elGR } from "@mui/x-data-grid/locales";

export const gridGreekLocales = {
  ...elGR.components.MuiDataGrid.defaultProps.localeText,
  filterOperatorDoesNotContain: "δεν περιέχει",
  filterOperatorDoesNotEqual: "δεν ισούται με",
};

export const gridEnglishLocales =
  enUS.components.MuiDataGrid.defaultProps.localeText;
